import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Room service',
      [RoomServiceLocationType.TableService]: 'Table service',
    },
    [ORDER_METHODS.PICKUP]: 'Pickup',
    [ORDER_METHODS.DELIVERY]: 'Delivery',
  },
};
